import React, { Component } from "react";
import { Button, Tabs, Icon, Tooltip } from "antd";
import SideNav from "../../businessOffer/SideNav";
import "./index.less";
import API_URL from "../../../common/url";
import $ from "../../../common/AjaxRequest";
import QuotationParams from "./components/QuotationParams";
import QuotationTotalPrice from "./components/QuotationTotalPrice";
import Cover from "./components/Cover";
import Intro from "./components/Intro";
import QuotationDetail from "./components/QuotationDetail";
import PaymentPlan from "./components/PaymentPlan";
import CrcServiceContent from "./CrcServiceContent";
import { saveEvaluateParams } from '../../../actions/clinicalEvaluationActions';
import { connect } from "react-redux";
import ExportVisitQuotation from "./components/ExportVisitQuotation";

const TabPane = Tabs.TabPane;

class VisitQuotation extends Component {
    state = {
        recordData: {},
        quotationData: {},
        activeKey: "Cover",
        tipTitle: "",
        serveFeeType: '',
    };

    componentDidMount() {
        this.loadRecordData();
        this.getClinicalQuotationRecord();
    }

    componentWillUnmount() {
        this.props.saveEvaluateParams({ 
            isClinicalEvaluation: undefined,
        });
    }
    loadRecordData = () => {
        const { evaluateRecordId } = this.props.match.params;
        const { evaluateParams: { isClinicalEvaluation } } = this.props;
        const url = isClinicalEvaluation ? API_URL.evaluate.queryEvaluateRecords : API_URL.evaluate.queryQuotationListByParams;
        const options = {
            method: "POST",
            url,
            data: {
                evaluateRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                const { datas } = res;
                this.setState({
                    recordData: datas[0] || {},
                });
            },
        };
        $.sendRequest(options);
    };

    //获取报价单Id及tab页权限
    getClinicalQuotationRecord = () => {
        const { evaluateRecordId } = this.props.match.params;
        const options = {
            method: "POST",
            url: API_URL.evaluate.getClinicalQuotationRecord,
            data: {
                evaluateRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                const { data } = res;
                this.setState(
                    {
                        quotationData: data,
                    },
                    () => {
                        this.queryServeFeeType();
                    }
                );
            },
        };
        $.sendRequest(options);
    };

    queryServeFeeType = () => {
        const { evaluateRecordId } = this.props.match.params;
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryServeFeeType,
            data: { evaluateRecordId },
            dataType: "json",
            doneResult: (res) => {
                const { serveFeeType } = res;
                this.setState({
                    serveFeeType,
                },() => {
                    this.queryQuotationVisitFloating();
                })
            },
        };
        $.sendRequest(options);
    }


    queryQuotationVisitFloating = () => {
        const {
            quotationData: { clinicalQuotationRecordId },
            serveFeeType,
        } = this.state;
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryQuotationVisitFloating,
            data: {
                clinicalQuotationRecordId,
                serveFeeType,
            },
            dataType: "json",
            doneResult: (res) => {
                const { data } = res;
                let arr = (data || "").split("\n");
                let title = (
                    <div>
                        {arr.map((el) => (
                            <span>
                                {el}
                                <br />
                            </span>
                        ))}
                    </div>
                );
                this.setState({
                    tipTitle: title,
                });
            },
        };
        $.sendRequest(options);
    };

    handelTabChange = (value) => {
        this.setState({
            activeKey: value,
        });
    };

    publishQuote = () => {
        const { quotationData: { clinicalQuotationRecordId } } = this.state;
        this.ExportVisitQuotationRef.show(clinicalQuotationRecordId, 'publish');
    };

    export = () => {
        const { quotationData: { clinicalQuotationRecordId } } = this.state;
        this.ExportVisitQuotationRef.show(clinicalQuotationRecordId, 'export');
    };

    leave = () => {
        this.props.saveEvaluateParams({ feedBack: true });
        window.history.go(-1);
    }

    render() {
        const { activeKey, recordData, quotationData, tipTitle } = this.state;
        const { evaluateCode, evaluateRecordId, evaluateStatus, bdBaAuth } = recordData;
        const {
            researchProductTypeId,
            evaluateServeCode,
            clinicalQuotationRecordId,
            paymentPlanHasInflation,
        } = quotationData || {};
        const params = {
            key: activeKey,
            activeKey,
            clinicalQuotationRecordId,
            recordData,
        }
        const TabsConfig = [
            {
                title: "封面",
                key: "Cover",
                Dom: (
                    <Cover 
                        evaluateRecordId={evaluateRecordId}
                        clinicalQuotationRecordId={clinicalQuotationRecordId}
                        recordData={recordData}
                    />
                ),
            },
            {
                title: "公司简介",
                key: "Intro",
                Dom: (
                    <Intro 
                        {...params}
                    />
                ),
            },
            {
                title: "报价参数",
                key: "QuotationParams",
                Dom: (
                    <QuotationParams 
                        {...params}
                    />
                ),
            },
            {
                title: "总价-详细版",
                key: "DetailedTotalPrice",
                Dom: (
                    <QuotationTotalPrice
                        {...params}
                    />
                ),
            },
            {
                title: "总价-简版",
                key: "SimpleTotalPrice",
                Dom: (
                    <QuotationTotalPrice
                        {...params}
                    />
                ),
            },
            {
                title: "报价明细-详细版",
                key: "DetailedQuotation",
                Dom: (
                    <QuotationDetail
                        {...params}
                    />
                ),
            },
            {
                title: "报价明细-简版",
                key: "SimpleQuotation",
                Dom: (
                    <QuotationDetail
                        {...params}
                    />
                ),
            },
            {
                title: "CRC服务内容",
                key: "CRCServiceContent",
                show: researchProductTypeId != 5,
                Dom: <CrcServiceContent
                        tabType="Crc"
                        {...params}
                    />,
            },
            {
                title: "CRC服务内容-器械",
                key: "CRCServiceContentInstrument",
                show: researchProductTypeId == 5,
                Dom: <CrcServiceContent
                        tabType="Crc"
                        {...params}
                    />,
            },
            {
                title: "全权启动-服务内容",
                key: "fullStartServiceContent",
                show: evaluateServeCode == "start_plenipotentiary",
                Dom: <CrcServiceContent
                        tabType="Start"
                        {...params}
                    />,
            },
            {
                title: "主导启动-服务内容",
                key: "dominantStartServiceContent",
                show: evaluateServeCode == "start_leading",
                Dom: <CrcServiceContent
                        tabType="Start"
                        {...params}
                    />,
            },
            {
                title: "深度协助-服务内容",
                key: "deepAssistServiceContent",
                show: evaluateServeCode == "start_deeply_assist",
                Dom: <CrcServiceContent
                        tabType="Start"
                        {...params}
                    />,
            },
            {
                title: "基础协助-服务内容",
                key: "basicAssistServiceContent",
                show: evaluateServeCode == "start_ordinary_assist",
                Dom: <CrcServiceContent
                        tabType="Start"
                        {...params}
                    />,
            },
            {
                title: "付款计划-详细版",
                key: "DetailedPaymentPlan",
                Dom: (
                    <PaymentPlan
                        {...params}
                        getClinicalQuotationRecord={this.getClinicalQuotationRecord}
                        paymentPlanHasInflation={paymentPlanHasInflation}
                    />
                ),
            },
            {
                title: "付款计划-简版",
                key: "SimplePaymentPlan",
                Dom: (
                    <PaymentPlan
                        {...params}
                        getClinicalQuotationRecord={this.getClinicalQuotationRecord}
                        paymentPlanHasInflation={paymentPlanHasInflation}
                    />
                ),
            },
        ];
        return (
            <div className="content visitAssess">
                <SideNav selectKey="record" />
                <div className="main">
                <div className="tab_fixed">
                    <div style={{ overflow: "hidden" }}>
                        <div
                            style={{
                                float: "left",
                                margin: "10px",
                                marginTop: 0,
                            }}
                        >
                            <i
                                className="icon iconfont"
                                style={{
                                    marginRight: 4,
                                    fontSize: "20px",
                                    color: "#1296DB",
                                }}
                            >
                                &#xe65b;
                            </i>
                            {`临床评估单号：${evaluateCode}`}
                        </div>
                        <Button
                            type="primary"
                            className="export—btn"
                            onClick={() => this.export()}
                        >
                            导出
                        </Button>
                        {
                            (bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') &&
                                <Button
                                    className="btn-yellow"
                                    style={{ marginLeft: 10 }}
                                    onClick={() => this.publishQuote()}
                                >
                                    发布报价
                                </Button>
                        }
                        <div
                            style={{
                                float: "right",
                                marginRight: 10,
                                color: "#1296DB",
                                cursor: "pointer",
                            }}
                            onClick={() => this.leave()}
                        >
                            <i
                                className="icon iconfont"
                                style={{ marginRight: 4, fontSize: "20px" }}
                            >
                                &#xe63d;
                            </i>
                            返回
                        </div>
                    </div>
                        <Tabs
                            onChange={this.handelTabChange}
                            type="card"
                            activeKey={activeKey}
                        >
                            {TabsConfig.map((teb) => {
                                const { show = true } = teb;
                                if (show)
                                    return (
                                        <TabPane tab={teb.title} key={teb.key}>
                                        </TabPane>
                                    );
                            })}
                        </Tabs>
                    </div>
                    {TabsConfig.find(el => el.key === activeKey).Dom}
                </div>
                <Tooltip
                    placement="left"
                    title={tipTitle}
                    overlayClassName="head_tip"
                >
                    <a className="floatingIcon" onMouseEnter={() => this.queryQuotationVisitFloating()}>
                        <Icon type="appstore-o" style={{ fontSize: 25 }} />
                    </a>
                </Tooltip>
                <ExportVisitQuotation ref={el => this.ExportVisitQuotationRef = el}/>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        evaluateParams: state.clinicalEvaluationState.evaluateParams,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveEvaluateParams: (params) => dispatch(saveEvaluateParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisitQuotation);



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/VisitQuotation.js